<template>
	<div class="card mb-0 shadow">
		<div class="card-body">
			<div class="tab-content">
				<div class="animate__animated animate__fadeIn">
					<div class="row">
						<div class="col-12">
							<modulo-comentario module="Paf" :id="acompanhamento.id" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ["acompanhamento"],
	data() {
		return {};
	},
};
</script>
